<template>
  <article class="article-view">
    <template v-if="article && !error">
      <h1>
        {{ article.title }}
      </h1>
      
      <p class="article-view__date">
        {{ article.date | formatDate }}
      </p>
      
      <section v-html="article.content" />
    </template>

    <p v-if="error && !article">
      Ошибка: {{ error.message }}
    </p>
    
    <loader-dots v-if="!error && !article" />
  </article>
</template>

<script>
import apiApp from '@src/api/app';

import LoaderDots from '@@/shared/loaders/LoaderDots';

export default {
  components: {
    LoaderDots
  },

  data: () => ({
    article: null, // ?ApiNormacsInfoPublication
    error: null
  }),

  beforeRouteUpdate(to, from, next) {
    this.loadArticle(to.params.section, to.params.id);
    next();
  },

  created() {
    let params = this.$route.params;

    this.loadArticle(params.section, params.id);
  },

  methods: {
    async loadArticle(sectionId, articleId) {
      try {
        this.article = await apiApp.getNormacsInfoPublication(sectionId, articleId)
      } catch(err) {
        this.error = err
      }
    }
  }
};
</script>

<style>
.article-view {
  margin: 2em auto 3em;
  max-width: 800px;
}
.article-view__date {
  text-align: right;
  font-style: italic;
}
</style>
